import React from 'react';

interface TbcLoadedSummaryProps {
    logCount: number;
    healerCount: number;
    playerCountLabel?: string;
}

const TbcLoadedSummary: React.FC<TbcLoadedSummaryProps> = ({
    logCount,
    healerCount,
    playerCountLabel = 'Healers found:',
}) => {
    return (
        <div className="results-summary" style={{ marginBottom: '16px' }}>
            <div className="summary-card">
                <div className="summary-stats">
                    <div className="stat">
                        <span className="stat-label">Logs loaded:</span>
                        <span className="stat-value">{logCount}</span>
                    </div>
                    <div className="stat">
                        <span className="stat-label">{playerCountLabel}</span>
                        <span className="stat-value">{healerCount}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TbcLoadedSummary;
